module.exports = __webpack_public_path__ + "static/media/facebookcontorno.91fd898f.svg";